<script>
import LKMunMehReviewForm from '@/views/LKMunMeh/Review/components/LKMunMehReviewForm.vue'

const FormContent = () => import(
  /* webpackChunkName: "LKMunMehReviewSecondFormContent" */
  '@/views/LKMunMeh/ReviewSecond/components/LKMunMehReviewSecondFormContent.vue'
)

export default {
  name: 'LKMunMehReviewSecondForm',
  extends: LKMunMehReviewForm,
  computed: {
    formContentComponent() {
      return FormContent
    },
  },
}
</script>
